import { OnInit, Component, ViewChild } from '@angular/core'
import { PerfilService } from 'src/app/services/perfil.service'
import { MatTableDataSource } from '@angular/material/table'
import { Perfil, PerfilPorUsuario, PerfisDoUsuario } from 'src/app/models/perfil'
import { FormControl } from '@angular/forms'
import { UnespConfirmDialogModel, UnespConfirmDialogComponent } from '@unesp/shared'
import { MatDialog as MatDialog } from '@angular/material/dialog'
import { UnespCoreMessageService } from '@unesp/core'
import { PropgAdicionaPerfilComponent } from '../adiciona-perfil/adiciona-perfil.component'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

@Component({
  selector: 'app-lista-perfil',
  templateUrl: './lista-perfil.component.html',
  styleUrls: ['./lista-perfil.component.css'],
  standalone: false
})
export class PropgListaPerfilComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  dataSource: MatTableDataSource<any> = new MatTableDataSource()
  perfis: Perfil[] = []
  opcaoPerfilFC: FormControl = new FormControl('')
  identificacao: string = ''

  buscaPerfis = new FormControl('')

  perfisDoUsuario: PerfisDoUsuario[] = []

  colunasGrid: string[] = ['nome', 'email', 'action']
  perfil: string | undefined

  constructor(
    private perfilService: PerfilService,
    public dialog: MatDialog,
    private unespCoreMessageService: UnespCoreMessageService
  ) {}

  ngOnInit() {
    this.listarPerfis()
    this.opcaoPerfilFC.valueChanges.subscribe(value => this.listarUsuarios(value))
  }

  listarUsuarios(value: number) {
    this.perfilService.listaUsuariosDoPerfil(value).subscribe(usuarios => {
      this.dataSource.data = usuarios
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }

  excluir(usuarioDoPerfil: PerfilPorUsuario): void {
    let index = this.dataSource.data.indexOf(usuarioDoPerfil)
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Confirma a exclusão do usuario #${usuarioDoPerfil.nome}`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.perfilService.excluir(this.opcaoPerfilFC.value as number, usuarioDoPerfil.idUsuario).subscribe(result => {
          let tmp: PerfilPorUsuario[] = this.dataSource.data
          tmp.splice(index, 1)
          this.dataSource.data = tmp
          this.unespCoreMessageService.showMessageSuccess(`Usuário ${usuarioDoPerfil.nome} excluído com sucesso`)
        })
      }
    })
  }

  listarPerfis() {
    this.perfilService.listarPerfil().subscribe(perfil => {
      this.perfis = perfil as Perfil[]
    })
  }

  adicionarUsuarioDialog() {
    const idPerfil = this.opcaoPerfilFC.value
    const dialogRef = this.dialog.open(PropgAdicionaPerfilComponent, { data: { idPerfil } })
    dialogRef.afterClosed().subscribe(res => {
      if (res) this.listarUsuarios(idPerfil)
    })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }
}
